import type { Tour } from '../tour-types';

/**
 * Clients, an agency-only screen. The row anchors (select, rename, active, remove) sit on
 * the first row of the table, so they exist once there is at least one client; until
 * then the screen is its first-run state and the tour waits.
 */
export const clientsTour: Tour = {
  key: 'clients',
  version: 1,
  routes: ['/clients'],
  steps: [
    {
      anchor: 'clients-create',
      placement: 'bottom',
      requires: 'clients:manage',
      title: 'Add a client',
      body: 'Each client gets its own websites, experiments and plan. You choose the plan, and it is billed to you.',
    },
    {
      anchor: 'clients-list',
      placement: 'bottom',
      title: 'Your clients',
      body: 'Every company you run tests for. Use the search above it to find one by name.',
    },
    {
      anchor: 'clients-select',
      title: 'Work inside a client',
      body: 'Select switches the whole dashboard to this client and its first website. You can also switch from the header.',
    },
    {
      anchor: 'clients-rename',
      requires: 'clients:manage',
      title: 'Rename',
      body: 'Change the name this client goes by everywhere in the dashboard. Press Enter to save it, or Escape to keep the old one.',
    },
    {
      anchor: 'clients-active',
      placement: 'left',
      title: 'Active',
      body: 'Turn a client off to hide it from the client picker in the header. Its data stays, and only this browser is affected.',
    },
    {
      anchor: 'clients-remove',
      placement: 'left',
      requires: 'clients:manage',
      title: 'Remove a client',
      body: 'For a client you no longer work for: it is removed from your account and its plan is cancelled. This cannot be undone, so turn it off instead if you only want it out of the way.',
    },
  ],
};
